import {Fragment} from "preact";
import {iconLoader} from "../../../assets";

const ScopedLoader = () => {
    return (
        <Fragment>
            <div className={"absolute z-10 inset-0 w-full h-full flex flex-row items-center justify-center"}>
                <img
                    src={iconLoader}
                    className={"select-none absolute z-20 dark:grayscale"}
                    alt="Loader icon"
                />
                <div className={"w-full h-full bg-white opacity-50"} />
            </div>
        </Fragment>
    )
}

export default ScopedLoader;
